import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '@environments/environment';

// Import feature reducers (will be created later)
// import { authReducer, AuthState } from '../features/auth/store/auth.reducer';
// import { notificationReducer, NotificationState } from './notification/notification.reducer';

// App State Interface
export interface AppState {
  // auth: AuthState;
  // notifications: NotificationState;
}

// Root Reducers
export const reducers: ActionReducerMap<AppState> = {
  // auth: authReducer,
  // notifications: notificationReducer,
};

// Meta Reducers
export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];

// Selectors (will be expanded)
export * from './selectors';
